import * as React from 'react';
import { DashBg } from '../../components/Dashboard/DashUI';

const Dashboard = () => <DashBg>Dashboard</DashBg>;

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.tsx